import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Card,
  Text,
  ButtonGroup,
  Button,
  Modal,
  TextField,
  Select,
  BlockStack,
  InlineStack,
  Box,
  Spinner,
  FormLayout,
  Image,
  Link,
  Divider,
  Tag,
  Toast,
  TextContainer,
  Icon,
  Badge,
  InlineError,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import MyPagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import {
  CategoriesIcon,
  EditIcon,
  ImagesIcon,
  LinkIcon,
  PlusCircleIcon,
  TeamIcon,
} from "@shopify/polaris-icons";
import countries from "../../../Data/countries.json";
import lebanonIcon from "../../../Assets/Images/lb.svg";
import iraqIcon from "../../../Assets/Images/iq.svg";
import egyptIcon from "../../../Assets/Images/eg.svg";
import { MultiSelect } from "react-multi-select-component";

const ProjectsList = () => {
  const navigate = useNavigate();

  // Filters state
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All");
  const [typeFilter, setTypeFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [countryFilter, setCountryFilter] = useState("All");
  const [timeline, setTimeline] = useState("All");
  const timelineButtons = [
    { label: "All", value: "All" },
    { label: "This Week", value: "week" },
    { label: "This Month", value: "month" },
  ];

  // Data state
  const [items, setItems] = useState(null);
  const [result, setResult] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 50;
  const refBoolPage = useRef(true);
  const [activeShow, setActiveShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Toast
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive(!active), []);
  const [toastContent, setToastContent] = useState(
    "This page has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  // Modal Delete
  const [activeDelete, setActiveDelete] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);

  const handleChangeModalShow = useCallback(() => {
    setActiveShow(!activeShow);
  }, [activeShow]);

  const handleChangeModalDelete = useCallback(() => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, [activeDelete]);

  const handleRowClick = (id) => {
    navigate(`/admin/task-manager/projects/${id}/tasks`);
    //setCurrentIndex(index);
    //setActiveShow(true);
  };

  const handleAddItem = () => {
    navigate("/admin/task-manager/projects/new");
  };

  const handleEdit = (id) => {
    navigate(`/admin/task-manager/projects/${id}`);
  };

  const handleScreenshots = (id) => {
    navigate(`/admin/projects/${id}/screenshots`);
  };

  const handleNext = () => {
    if (currentIndex < result.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const [optionsCountries, setOptionsCountries] = useState([]);
  const [country, setCountry] = useState("");

  useEffect(() => {
    fetchData();
  }, [page, search, countryFilter, statusFilter, country]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("per_page", perPage);
      params.append("page", refBoolPage.current ? page : 1);
      if (search) params.append("filter[title]", search);
      if (statusFilter !== "All") params.append("filter[type]", statusFilter);

      if (country !== "") params.append("filter[country]", country);
      // if (countryFilter !== "All")
      //   params.append("filter[location]", countryFilter);

      const response = await axios.get(`/task-manager-projects`, { params });
      const data = response.data.data.data;

      console.log("data=", data);
      setResult(data);
      setItems(
        data.map((item, index) => [
          <div onClick={() => handleRowClick(item.id)} className="row_click">
            {item.title || "-"}
          </div>,
          <div onClick={() => handleRowClick(item.id)} className="row_click">
            <Badge tone={item.type.id === 1 ? "success" : "default"}>
              {item.type?.description || "-"}
            </Badge>
          </div>,
          // <div onClick={() => handleRowClick(item.id)} className="row_click">
          //   {item.project_id !== null ? "Yes" : "No"}
          // </div>,
          <div className="me-3">
            <ButtonGroup>
              {/* <Button
                onClick={() => handleScreenshots(item.id)}
                icon={ImagesIcon}
              >
                Screenshots
              </Button> */}
              {/* <Button
                onClick={() =>
                  navigate(`/admin/task-manager/projects/${item.id}/categories`)
                }
                icon={EditIcon}
              >
                Categories
              </Button>
              <Button
                onClick={() =>
                  navigate(`/admin/task-manager/projects/${item.id}/statuses`)
                }
                icon={EditIcon}
              >
                Statuses
              </Button> */}
              <Button onClick={() => handleTeam(item.id)} icon={TeamIcon}>
                Team
              </Button>
              <Button onClick={() => handleEdit(item.id)} icon={EditIcon}>
                Edit
              </Button>
            </ButtonGroup>
          </div>,
        ])
      );

      setTotalPages(response.data.data.total);
      setIsListEmpty(!data.length);
    } catch (err) {
      console.error(err);
      setIsListEmpty(true);
    }
    setIsLoading(false);
  };

  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage} />
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
    </div>
  ) : isLoading ? (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  ) : null;
  const [countryButtons, setCountryButtons] = useState([]);
  // useEffect(() => {
  //   axios
  //     .get("/settings/countries")
  //     .then((res) => {
  //       const countriesData = res?.data?.data || [];
  //       const options = [
  //         { label: "All", value: "" },
  //         { label: "Mutual", value: "All" },
  //         ...countriesData.map((country) => ({
  //           label: country.name,
  //           value: country.name,
  //           flag: country.flag,
  //         })),
  //       ];
  //       setCountryButtons(options);
  //       // setCountry(options?.[0]);
  //     })
  //     .catch((err) => console.log(err));
  // }, []);

  const [teamModal, setTeamModal] = useState(false);
  const [teamLoading, setTeamLoading] = useState(false);
  const [teamProjectId, setTeamProjectId] = useState(null);
  const [peopleOptions, setPeopleOptions] = useState([]);
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [errorsTeam, setErrorsTeam] = useState({});
  const handleTeam = (id) => {
    setTeamProjectId(id);
    setTeamModal(true);
  };
  useEffect(() => {
    if (!teamModal || !teamProjectId) return;
    fetchTeamData();
  }, [teamModal, teamProjectId]);
  const fetchTeamData = async () => {
    try {
      setTeamLoading(true);

      // 1️⃣ Fetch all people
      const peopleRes = await axios.get("/people?only-with-user");
      const people = peopleRes.data?.data?.data || [];

      const formattedPeople = people.map((p) => ({
        label: [p.user?.first_name, p.user?.last_name]
          .filter(Boolean)
          .join(" "),
        value: p.user?.id,
      }));
      console.log("formattedPeople=", formattedPeople);

      setPeopleOptions(formattedPeople);

      // 2️⃣ Fetch the project (with its users)
      const projectRes = await axios.get(
        `/task-manager-projects/${teamProjectId}`
      );
      const project = projectRes.data?.data || {};

      const assignedUsers = project.users || [];
      console.log("assignedUsers=", assignedUsers);

      // 3️⃣ Pre-select with SAME format as MultiSelect needs
      const selected = assignedUsers.map((u) => ({
        label: [u.first_name, u.last_name].filter(Boolean).join(" "),
        value: u.id,
      }));
      // console.log("selected=", selected);
      // // Remove users who no longer exist in people list
      // const selectedPeopleClean = selected.filter((s) =>
      //   formattedPeople.some((p) => p.value === s.value)
      // );
      // console.log("selectedPeopleClean=", selectedPeopleClean);

      console.log("selected=", selected);
      setSelectedPeople(selected);
    } catch (err) {
      console.log(err);
    } finally {
      setTeamLoading(false);
    }
  };

  const handleSaveTeam = async () => {
    if (!selectedPeople.length) {
      setErrorsTeam({ assignees: "Please select at least one member" });
      return;
    }

    setErrorsTeam({});
    setTeamLoading(true);

    try {
      const formData = new FormData();
      selectedPeople.forEach((m, i) => {
        formData.append(`users[${i}]`, m.value);
      });

      await axios.post(
        `/task-manager-projects/${teamProjectId}/assign-users`,
        formData
      );

      setTeamModal(false);
      setSelectedPeople([]);
      setTeamProjectId(null);
    } catch (err) {
      console.log(err);
    } finally {
      setTeamLoading(false);
    }
  };

  return items ? (
    <Page
      title="Projects"
      primaryAction={
        <Button variant="primary" onClick={handleAddItem} icon={PlusCircleIcon}>
          Add Project
        </Button>
      }
      backAction={{ onAction: () => navigate(-1) }}
      // secondaryActions={
      //   <Button
      //     onClick={() => navigate("/admin/projects/edit/categories")}
      //     icon={CategoriesIcon}
      //   >
      //     Categories
      //   </Button>
      // }
      fullWidth
    >
      {/* Filters Card */}
      <FormLayout>
        <Card>
          <BlockStack gap="500">
            {/* Filters + Country buttons in one row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // ✅ centers vertically
                flexWrap: "wrap",
                gap: "1rem",
              }}
            >
              {/* 🔹 Left side: Filters */}
              <InlineStack gap="300" wrap align="center">
                <Box minWidth="260px">
                  <TextField
                    label="Search projects"
                    value={search}
                    onChange={setSearch}
                    autoComplete="off"
                    placeholder="Search by name"
                  />
                </Box>

                <Select
                  label="Status"
                  value={statusFilter}
                  onChange={setStatusFilter}
                  options={[
                    { label: "All", value: "All" },
                    { label: "Active", value: "1" },
                    { label: "Archived", value: "2" },
                  ]}
                />
              </InlineStack>

              {/* 🔹 Right side: Country buttons */}
              {/* <div
                style={{
                  display: "flex",
                  alignItems: "center", // ✅ aligns button group with filters
                }}
              >
                <ButtonGroup segmented>
                  {countryButtons.map((t) => (
                    <Button
                      key={t.value}
                      pressed={country === t.value}
                      onClick={() => setCountry(String(t.value))}
                    >
                      {t.flag && (
                        <img
                          src={t.flag}
                          alt={t.label}
                          style={{ width: 20, marginRight: 6 }}
                        />
                      )}
                      {t.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </div> */}
            </div>
          </BlockStack>
        </Card>

        {/* DataTable */}
        {items?.length ? (
          <Card padding="0">
            <DataTable
              columnContentTypes={["text", "text", "text", "text"]}
              headings={["Name", "Status", ""]}
              rows={items}
              verticalAlign="middle"
              stickyHeader
              footerContent={
                items?.length &&
                `Showing ${items.length} of ${totalPages} results`
              }
            />
          </Card>
        ) : (
          <Card>
            <div
              style={{
                display: "flex",
                justifyContent: "middle",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ width: "25%" }}>
                <img src={emptyListImage}></img>
              </div>
              <div className="mb-3">
                <Text variant="headingLg" as="h5" color="subdued">
                  No results found
                </Text>
              </div>
              <br />
            </div>
          </Card>
        )}

        {/* Pagination */}
        {Math.ceil(totalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <MyPagination
              count={Math.ceil(totalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            />
          </div>
        )}
      </FormLayout>
      {/* Modals */}
      <Modal
        open={teamModal}
        onClose={() => setTeamModal(false)}
        title="Assign People to this Project"
        primaryAction={{
          content: "Save",
          onAction: handleSaveTeam,
          loading: teamLoading,
        }}
        secondaryActions={[
          { content: "Cancel", onAction: () => setTeamModal(false) },
        ]}
      >
        <Modal.Section>
          {teamLoading ? (
            <Spinner size="large" />
          ) : (
            <FormLayout>
              <Text variant="headingMd">Select Members</Text>

              <div style={{ position: "relative", zIndex: 9999 }}>
                <MultiSelect
                  options={peopleOptions}
                  value={selectedPeople}
                  onChange={setSelectedPeople}
                  labelledBy="Select team members"
                />
                {errorsTeam.assignees && (
                  <InlineError message={errorsTeam.assignees} />
                )}
              </div>
              <div style={{ height: "7rem" }}></div>
            </FormLayout>
          )}
        </Modal.Section>
      </Modal>

      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default ProjectsList;
